import { Table } from '@mantine/core';

import { paymentProviderTypes } from '../../types';

import { BodyRow } from './BodyRow';

import { Departments } from '@/types';

type PaymentProvidersTableProps = {
  department: Departments;
  paymentProviders: paymentProviderTypes.PaymentProvider[];
};

export const PaymentProvidersTable = ({
  department,
  paymentProviders,
}: PaymentProvidersTableProps) => {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Название</Table.Th>
          <Table.Th>Ключ</Table.Th>
          <Table.Th>Блок</Table.Th>
          <Table.Th>Действия</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {paymentProviders?.map((paymentProvider) => (
          <BodyRow
            key={paymentProvider._id}
            department={department}
            paymentProvider={paymentProvider}
          />
        ))}
      </Table.Tbody>
    </Table>
  );
};
